// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout___rYxFl","sider":"sider___oLA2k","menu":"menu___29TT0","menuItem":"menuItem___2Y-Q8","icon":"icon___35zea","text":"text___1Kid9","content":"content___313j-"};